import React from "react";
import { CheckBox } from "@app/components/Common";
import { useTranslation } from "react-i18next";
import { COLORS } from "@app/constants";
import useTradeStore from "@app/hooks/trade/tradeStore";
import {useMobileDimensions} from "@app/hooks";

const DerivativesCheckBox = ({ title, checked, action }: any) => {
  const { t } = useTranslation();
  const { data: store } = useTradeStore();
  const checkType = store?.checkType;
  const { isMobile } = useMobileDimensions();

  return (
    <CheckBox
      labelStyle={{ marginTop: 0, }}
      inputStyle={{
        width: title === 'postOnly' ? "17px" : "16.5px",
        height: "13px",
        border: `1px solid ${
          checkType
            ? checkType === "goodTillCanceled" || title === "reduceOnly"
              ? COLORS.lightGray
              : COLORS.lightGray5
            : COLORS.lightGray
        }`,
      }}
      textStyle={{
        paddingTop: isMobile ? 2 : 0,
        whiteSpace: "nowrap",
        fontSize: 12,
        color: checkType
          ? checkType === "goodTillCanceled" || title === "reduceOnly"
            ? COLORS.lightGray
            : COLORS.lightGray5
          : COLORS.lightGray,
      }}
      label={title && t(title)}
      value={checked}
      onChange={(e) => action(e.target.checked)}
    />
  );
};

export default DerivativesCheckBox;
